/* import __COLOCATED_TEMPLATE__ from './gender-state-row.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();